/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-unused-vars: 0, no-use-before-define: 0, no-var: 0 */
/* globals _, Backbone, mixpanel, mp */

_.namespace(`mp.static.landing.marketing`, function(ns) {
  'use strict';

  var CUBIC_BEZIER_CURVE = `cubic-bezier(0.67, 0.01, 0.23, 1)`;

  ns.pages.index = function() {
    mp.utility.track_ga(`send`, `pageview`);
    mixpanel.track(`homepage new`, {
      mp_note: `Came from: ` + document.referrer,
      user_agent: window.navigator.userAgent,
      version: `2016`,
    });

    var signupFlow = new Backbone.widgets.SignupFreePlanFlow({
      source: `homepage`,
      step_source: `homepage`,
    });

    var onGetStartedButtonClick = function(ev) {
      ev.preventDefault();
      startRegistration();
    };

    var onInputEmailChanged = function(ev) {
      if (ev.which === 13) {
        ev.preventDefault();
        ev.stopPropagation();
        startRegistration();
      } else {
        removeEmailError();
      }
    };

    var removeEmailError = function() {
      $(`.get-started-email`).removeClass(`error`);
    };

    var showEmailError = function() {
      $(`.get-started-email`).addClass(`error`);
    };

    var startRegistration = function() {
      var emailVal = $(`.input-email`).val();
      var validEmail = /(.+)@(.+){2,}\.(.+){2,}/.test(emailVal);

      if (!validEmail) {
        showEmailError();
        return;
      }

      signupFlow.show(emailVal);
    };

    $(`.started`).off(`click`, onGetStartedButtonClick).click(onGetStartedButtonClick);
    $(`.input-email`).off(`keydown`, onInputEmailChanged).keydown(onInputEmailChanged);

    var $carousel_quotes = $(`.carousel-quotes`);
    $carousel_quotes.slick({
      arrows: false,
      autoplay: false,
      centerMode: true,
      centerPadding: 0,
      cssEase: CUBIC_BEZIER_CURVE,
      slidesToShow: 3,
      speed: 800,
      vertical: true,
    }).removeClass(`hidden`);

    $(`.carousel-scroll-button.up`).click(function() {
      $carousel_quotes.slick(`slickPrev`);
    });

    $(`.carousel-scroll-button.down`).click(function() {
      $carousel_quotes.slick(`slickNext`);
    });

    var show_bubbles_if_visible = function() {
      if ($(window).scrollTop() + $(window).height() > $(`.testimonies`).position().top + 600) {
        $(`.company-icon-container`).removeClass(`hidden`);
        $(window).off(`scroll`, show_bubbles_if_visible);
      }
    };

    show_bubbles_if_visible();
    $(window).scroll(show_bubbles_if_visible);

    var $resources_carousel_panel = $(`.resources-carousel-panel`);
    $resources_carousel_panel.slick({
      arrows: false,
      autoplay: false,
      autoplaySpeed: 3000,
      cssEase: CUBIC_BEZIER_CURVE,
      lazyLoad: `ondemand`,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    $resources_carousel_panel.on(`afterChange`, function(event, slick, currentSlide, nextSlide) {
      var $dot_containers = $(`.carousel-panel-dots .dot-container`);
      if ($dot_containers.length > currentSlide) {
        _update_dot($dot_containers.eq(currentSlide).find(`.dot`));
      }

      _reset_timer();
    });

    $(`.resources-carousel-panel`).on(`beforeChange`, function(event, slick, currentSlide, nextSlide) {
      $(`.resources-carousel-panel-container`).removeClass(`timer-start`);
    });

    // this is to workaround a problem slick has where afterChange gets called when you hover - autoplay
    // is off but this event still gets fired
    $resources_carousel_panel.mouseenter(function() {
      _stop_autoplay();
    });

    $resources_carousel_panel.mouseleave(function() {
      _start_autoplay();
    });

    _show_carousel_panel(`events`);

    $(`.navigation-button-container`).click(function(ev) {
      _hide_carousel_panel();

      var classList = ev.currentTarget.classList;
      if (classList.contains(`events`)) {
        _show_carousel_panel(`events`);
        mixpanel.track(`Clicked on Updates Button`, {'Update Type': `Events`});
      } else if (classList.contains(`ebooks`)) {
        _show_carousel_panel(`ebooks`);
        mixpanel.track(`Clicked on Updates Button`, {'Update Type': `eBooks/Reports`});
      } else if (classList.contains(`blog`)) {
        _show_carousel_panel(`blog`);
        mixpanel.track(`Clicked on Updates Button`, {'Update Type': `Blog`});
      } else if (classList.contains(`news`)) {
        _show_carousel_panel(`news`);
        mixpanel.track(`Clicked on Updates Button`, {'Update Type': `News`});
      }
    });

    var product_keys_tracking_info = {
      $selector: $(`section.product-keys`),
      event_name: `Scroll to Key Benefits`,
      was_on_screen: false,
    };

    var product_analytics_tracking_info = {
      $selector: $(`section.product-analytics`),
      event_name: `Scroll to Product Analytics`,
      was_on_screen: false,
    };

    var testimonies_tracking_info = {
      $selector: $(`section.testimonies`),
      event_name: `Scroll to Logos`,
      was_on_screen: false,
    };

    var resources_tracking_info = {
      $selector: $(`section.explore`),
      event_name: `Scroll to Events and Resources`,
      was_on_screen: false,
    };

    var get_started_email_tracking_info = {
      $selector: $(`section.getting-started-mixpanel-2`),
      event_name: `Scroll to the signup modal on Homepage`,
      was_on_screen: false,
    };

    // call this manually once as it's the first thing shown on screen once a users lands on this page
    mp.utility.section_viewed_tracking_helper(get_started_email_tracking_info);
    var section_tracking_updater = function() {
      mp.utility.section_viewed_tracking_helper(product_keys_tracking_info);
      mp.utility.section_viewed_tracking_helper(product_analytics_tracking_info);
      mp.utility.section_viewed_tracking_helper(testimonies_tracking_info);
      mp.utility.section_viewed_tracking_helper(resources_tracking_info);
      mp.utility.section_viewed_tracking_helper(get_started_email_tracking_info);
    };

    $(window).scroll(section_tracking_updater);

    $(`.carousel-scroll-button`).click(function() {
      mixpanel.track(`Click to view more testimonies`);
    });

    $(`.app-button.iphone`).click(function() {
      mixpanel.track(`Clicked App Store`, {
        Source: `Homepage`,
        Type: `Apple`,
      });
    });

    $(`.app-button.android`).click(function() {
      mixpanel.track(`Clicked App Store`, {
        Source: `Homepage`,
        Type: `Android`,
      });
    });

    $(`.resource-detail-container`).click(function(ev) {
      var properties = {};

      var class_list = ev.currentTarget.classList;
      if (class_list.contains(`events`)) {
        properties[`Card Type`] = `Event`;
      } else if (class_list.contains(`ebooks`)) {
        properties[`Card Type`] = `eBooks/Reports`;
      } else if (class_list.contains(`blog`)) {
        properties[`Card Type`] = `Blog`;

        if (class_list.contains(`bcg-digital-ventures`)) {
          properties[`Blog Slug`] = `data-driven-enterprise-innovation`;
          properties[`Blog Category`] = `Product`;
        } else if (class_list.contains(`new-york-times`)) {
          properties[`Blog Slug`] = `new-york-times-technology`;
          properties[`Blog Category`] = `Product`;
        } else if (class_list.contains(`hard-thing-about-machine-learning`)) {
          properties[`Blog Slug`] = `hard-thing-about-machine-learning`;
          properties[`Blog Category`] = `Product`;
        }
      } else if (class_list.contains(`news`)) {
        properties[`Card Type`] = `News`;
      }

      mixpanel.track(`Clicked on Resource Card`, properties);
    });
  };

  function _show_carousel_panel(class_name) {
    var $resources_carousel_panel_container = $(`.resources-carousel-panel-container.` + class_name);
    var $dots = $(`.carousel-panel-dots`);

    var slickObject = $resources_carousel_panel_container.find(`.resources-carousel-panel`).slick(`getSlick`);

    $dots.empty();
    _.times(slickObject.slideCount, function(n) {
      $dots.append(`<div class="dot-container"><div class="dot"></div></div>`);
    });

    var $dot_containers = $(`.dot-container`);
    $dot_containers.eq(slickObject.currentSlide).find(`.dot`).addClass(`active`);
    $dot_containers.click(function(ev) {
      _update_dot($(ev.currentTarget).find(`.dot`));
      slickObject.slickGoTo($(ev.currentTarget).index());
    });

    $(`.navigation-button-container.` + class_name).addClass(`active`);
    $resources_carousel_panel_container.addClass(`fade-in`);
    $resources_carousel_panel_container.removeClass(`hidden fade-out`);

    _reset_timer();
  }

  function _update_dot($dot) {
    $(`.dot-container .dot`).removeClass(`active`);
    $dot.addClass(`active`);
  }

  function _hide_carousel_panel() {
    $(`.navigation-button-container`).removeClass(`active`);
    $(`.resources-carousel-panel-container`).removeClass(`fade-in`);
    $(`.resources-carousel-panel-container:not(.fade-in)`).addClass(`fade-out`);
    $(`.resources-carousel-panel-container`).one(`transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd`, function(ev) {
      $(`.resources-carousel-panel-container:not(.fade-in)`).addClass(`hidden`);
    });

    _stop_autoplay();
  }

  function _stop_autoplay() {
    $(`.resources-carousel-panel`).slick(`slickPause`);
    $(`.resources-carousel-panel-container`).removeClass(`timer-start`);
  }

  function _start_autoplay() {
    $(`.resources-carousel-panel-container.fade-in .resources-carousel-panel`).slick(`slickPlay`);
    $(`.resources-carousel-panel-container`).addClass(`timer-start`);
  }

  function _reset_timer() {
    _stop_autoplay();
    // the animation continues if you remove and add the class back too soon
    setTimeout(function() {
      _start_autoplay();
    }, 50);
  }
});

}.call(window));